
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import AppConstants from '../model/AppConstants';

const props = Vue.extend({
  props: {
    online: {
      type: Boolean,
      required: true,
    },
  },
});

@Component({})
export default class Status extends mixins(Vue, props) {
  get dev() {
    return process.env?.NODE_ENV === AppConstants.ENV.DEVELOPMENT;
  }
}
